/**
 * TripPastDueBadge — highlights planned trips whose departure day has passed.
 */
import styled from "styled-components";

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border: 1px solid #fecaca;
  background: #fef2f2;
  color: #b91c1c;
  white-space: nowrap;
`;

const TripPastDueBadge = () => (
  <Badge data-testid="trip-past-due-badge">Past due</Badge>
);

export default TripPastDueBadge;
